import usePrice from '@Hooks/usePrice';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import Icon from 'public/my_products.svg';
import { ProfileOrder } from 'types/Order';
import {
  Card,
  Content,
  Div,
  Header,
  IconWrapper,
  NumberOfProducts,
  ProductImageWrapper,
  ReservationNumber,
  Status,
  Total,
  TotalTitle,
} from './MyProductCard.styled';

interface Props {
  data: ProfileOrder;
}

export default function MyProductCard({ data }: Props) {
  const { t } = useTranslation('Profile');
  const { thePrice } = usePrice(data.total_price || 0);

  return (
    <Card href={`/profile/orders/${data.id}`}>
      <Header>
        <ReservationNumber>
          {t('order_number')} : {data?.order_id}
        </ReservationNumber>
        <Status>{data.status}</Status>
      </Header>
      <Content>
        <Div>
          <IconWrapper>
            <Image src={Icon} width={39.51} height={47.73} alt="my product icon" />
          </IconWrapper>
          <div>
            <NumberOfProducts>
              {data?.order_items?.length} {t('number_parts')}
            </NumberOfProducts>
            <Div>
              {data?.order_items?.map((item) => (
                <ProductImageWrapper key={item.id}>
                  {item.product.images.map((image) => (
                    <Image key={image.id} src={image.url} width={24} height={24} alt="product" />
                  ))}
                </ProductImageWrapper>
              ))}
            </Div>
          </div>
        </Div>
        <div>
          <TotalTitle>{t('total_price')}</TotalTitle>
          <Total>{thePrice}</Total>
        </div>
      </Content>
    </Card>
  );
}
